import { render, staticRenderFns } from "./Exhibition2.vue?vue&type=template&id=3fb77e2d&scoped=true"
import script from "./Exhibition2.vue?vue&type=script&lang=js"
export * from "./Exhibition2.vue?vue&type=script&lang=js"
import style0 from "./Exhibition2.vue?vue&type=style&index=0&id=3fb77e2d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fb77e2d",
  null
  
)

export default component.exports